<div [ngClass]="{'row': true, disabledContent: !enabled}">
    <div class="col p-0">
        <!-- Nav Tabs -->
        <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-3 text-uppercase'" [contentClass]="'p-0'"
            class="nav-reglas p-0">
            <!--Panel 1 CHEQUE-->
            <mdb-tab heading="Cheque">
                <form autocomplete="off" [formGroup]="formCheque" (ngSubmit)="agregarFormaPagoCheque()">
                    <div class="card mt-2 mb-2 wow">
                        <div class="filtros card-body justify-content-between pt-0 pb-0">
                            <div class="row filtros-body align-items-center mt-2">
                                <div class="col" style="max-width: 150px;">
                                    <div class="md-form">
                                        <input value="" type="text" id="nroDocumento" class="form-control"
                                            placeholder="Nro. Documento" required #nroDocumento
                                            formControlName="nroDocumento" onlyNumbers />
                                        <label for="nroDocumento">N° Doc.</label>
                                        <div *ngIf="
                                            formCheque.get('nroDocumento').invalid &&
                                                (formCheque.get('nroDocumento').dirty ||
                                                formCheque.get('nroDocumento').touched) &&
                                                (submittedmedioPago)
                                            ">
                                            <mdb-error
                                                *ngIf="formCheque.get('nroDocumento').hasError('required') || formCheque.get('nroDocumento').hasError('min')">
                                                Ingrese nro. documento
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col dato" style="max-width: 150px;">
                                    <div class="">
                                        <label for="montoEfectivo" class="title mb-0">Monto</label>
                                        <input value="" type="text" id="montoEfectivo" class="form-control"
                                            placeholder="Monto" required #montoEfectivo formControlName="monto"
                                            [(ngModel)]="montoPago" monto />
                                        <div *ngIf="
                                                formCheque.get('monto').invalid &&
                                                (formCheque.get('monto').dirty ||
                                                formCheque.get('monto').touched) &&
                                                (submittedmedioPago)
                                            ">
                                            <mdb-error
                                                *ngIf="formCheque.get('monto').hasError('required') || formCheque.get('monto').hasError('min')">
                                                Ingrese monto
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'"
                                            required formControlName="fecha">
                                        </mdb-date-picker>
                                        <label>Fecha</label>
                                        <div *ngIf="
                                                                                formCheque.get('fecha').invalid &&
                                                                                (formCheque.get('fecha').dirty ||
                                                                                formCheque.get('fecha').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formCheque.get('fecha').hasError('required')">
                                                Ingrese fecha
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-select label="Banco" placeholder="Banco" [filterEnabled]="true"
                                            formControlName="banco" [options]="optionsBancosTodos" required>
                                        </mdb-select>
                                        <div *ngIf="
                                                                                formCheque.get('banco').invalid &&
                                                                                (formCheque.get('banco').dirty ||
                                                                                formCheque.get('banco').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formCheque.get('banco').hasError('required')">
                                                Ingrese banco
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <input value="" type="text" id="nroCuenta" class="form-control"
                                            placeholder="Nro. cuenta" required #nroCuenta formControlName="nroCuenta" />
                                        <label for="nroCuenta">Nro. cuenta</label>
                                        <div *ngIf="
                                                                                formCheque.get('nroCuenta').invalid &&
                                                                                (formCheque.get('nroCuenta').dirty ||
                                                                                formCheque.get('nroCuenta').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error
                                                *ngIf="formCheque.get('nroCuenta').hasError('required') || formCheque.get('nroCuenta').hasError('minLength')">
                                                Ingrese nro. de cuenta
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>

                        <!-- FOOTER -->
                        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
                            <div></div>
                            <button mdbBtn type="submit" size="sm" color="secondary" size="sm" mdbWavesEffect
                                [disabled]="!enabled">
                                Agregar
                            </button>
                        </div>
                    </div>
                </form>
            </mdb-tab>

            <!--Panel 2 TRANSFERENCIA-->
            <mdb-tab heading="Transferencia">
                <form autocomplete="off" [formGroup]="formTransferencia" (ngSubmit)="agregarFormaPagoTransferencia()">
                    <div class="card mt-3 mb-2 wow">
                        <div class="filtros card-body justify-content-between" style="padding-bottom: 0 !important;">
                            <div class="row filtros-body align-items-center mt-2">
                                <!-- <div class="col" style="max-width: 150px;">
                                    <div class="md-form">
                                      <input value="" type="text" id="nroDocumento" class="form-control"
                                        placeholder="Nro. Documento" required #nroDocumento
                                        formControlName="nroDocumento" onlyNumbers />
                                          <label for="nroDocumento">N° Doc.</label>
                                            <div *ngIf="
                                                formTransferencia.get('nroDocumento').invalid &&
                                                    (formTransferencia.get('nroDocumento').dirty ||
                                                    formTransferencia.get('nroDocumento').touched) &&
                                                    (submittedmedioPago)
                                                ">
                                                <mdb-error
                                                    *ngIf="formTransferencia.get('nroDocumento').hasError('required') || formTransferencia.get('nroDocumento').hasError('min')">
                                                    Ingrese nro. documento
                                                </mdb-error>
                                            </div>
                                    </div>
                                </div> -->
                                <div class="col" style="max-width: 150px;">
                                    <div class="">
                                        <label for="montoEfectivo" class="title mb-0">Monto</label>
                                        <input value="" type="text" id="montoEfectivo" class="form-control"
                                            placeholder="Monto" required #montoEfectivo formControlName="monto"
                                            [(ngModel)]="montoPago" monto />
                                        <div *ngIf="
                                                formTransferencia.get('monto').invalid &&
                                                (formTransferencia.get('monto').dirty ||
                                                formTransferencia.get('monto').touched) &&
                                                (submittedmedioPago)
                                            ">
                                            <mdb-error
                                                *ngIf="formTransferencia.get('monto').hasError('required') || formTransferencia.get('monto').hasError('min')">
                                                Ingrese monto
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 150px;">
                                    <div class="md-form">
                                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'"
                                            required formControlName="fecha">
                                        </mdb-date-picker>
                                        <label>Fecha</label>
                                        <div *ngIf="
                                                                                formTransferencia.get('fecha').invalid &&
                                                                                (formTransferencia.get('fecha').dirty ||
                                                                                formTransferencia.get('fecha').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formTransferencia.get('fecha').hasError('required')">
                                                Ingrese fecha
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-select label="Banco" placeholder="Banco" [filterEnabled]="true"
                                            formControlName="banco" [options]="optionsBancosEmpresa">
                                        </mdb-select>
                                        <div *ngIf="
                                                                                formTransferencia.get('banco').invalid &&
                                                                                (formTransferencia.get('banco').dirty ||
                                                                                formTransferencia.get('banco').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formTransferencia.get('banco').hasError('required')">
                                                Ingrese banco
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-select label="Nro. cuenta" placeholder="Cuenta" [filterEnabled]="true"
                                            formControlName="nroCuenta" [options]="optionsCuentasBancosTransferencia">
                                        </mdb-select>
                                        <div *ngIf="
                                                                                formTransferencia.get('nroCuenta').invalid &&
                                                                                (formTransferencia.get('nroCuenta').dirty ||
                                                                                formTransferencia.get('nroCuenta').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formTransferencia.get('nroCuenta').hasError('required')">
                                                Seleccione nro. de cuenta
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <!-- FOOTER -->
                        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
                            <div></div>
                            <button mdbBtn type="submit" size="sm" color="secondary" size="sm" mdbWavesEffect
                                [disabled]="!enabled">
                                Agregar
                            </button>
                        </div>
                    </div>
                </form>
            </mdb-tab>

            <!--Panel 3 Efectivo-->
            <mdb-tab heading="Efectivo">
                <form autocomplete="off" [formGroup]="formEfectivo" (ngSubmit)="agregarFormaPagoEfectivo()">
                    <div class="card mt-2 mb-2 wow">
                        <div class="filtros card-body justify-content-between pt-0 pb-0">
                            <div class="row filtros-body align-items-center mt-2">
                                <div class="col" style="max-width: 150px;">
                                    <div class="">
                                        <label for="montoEfectivo" class="title mb-0">Monto</label>
                                        <input value="" type="text" id="montoEfectivo" class="form-control"
                                            placeholder="Monto" required #montoEfectivo formControlName="monto"
                                            [(ngModel)]="montoPago" monto [ngModel]="montoPago | numerico"
                                            (ngModelChange)="montoPago=$event" />
                                        <div *ngIf="
                                                formEfectivo.get('monto').invalid &&
                                                (formEfectivo.get('monto').dirty ||
                                                formEfectivo.get('monto').touched) &&
                                                (submittedmedioPago)

                                            ">
                                            <mdb-error
                                                *ngIf="formEfectivo.get('monto').hasError('required') || formEfectivo.get('monto').hasError('min')">
                                                Ingrese monto
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- FOOTER -->
                        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
                            <div></div>
                            <button mdbBtn type="submit" size="sm" color="secondary" size="sm" mdbWavesEffect
                                [disabled]="!enabled">
                                Agregar
                            </button>
                        </div>
                    </div>
                </form>
            </mdb-tab>

            <!--Panel 4 Depósito-->
            <mdb-tab heading="Depósito">
                <form autocomplete="off" [formGroup]="formDeposito" (ngSubmit)="agregarFormaPagoDeposito()">
                    <div class="card mt-2 mb-2 wow">
                        <div class="filtros card-body justify-content-between pt-0 pb-0">
                            <div class="row filtros-body align-items-center mt-2">
                                <div class="col" style="max-width: 150px;">
                                    <div class="md-form">
                                        <input value="" type="text" id="nroDocumento" class="form-control"
                                            placeholder="Nro. Documento" required #nroDocumento
                                            formControlName="nroDocumento" onlyNumbers />
                                        <label for="nroDocumento">N° Doc.</label>
                                        <div *ngIf="
                                                formDeposito.get('nroDocumento').invalid &&
                                                (formDeposito.get('nroDocumento').dirty ||
                                                formDeposito.get('nroDocumento').touched) &&
                                                (submittedmedioPago)
                                            ">
                                            <mdb-error
                                                *ngIf="formDeposito.get('nroDocumento').hasError('required') || formDeposito.get('nroDocumento').hasError('min')">
                                                Ingrese nro. de depósito
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 150px;">
                                    <div class="">
                                        <label for="montoEfectivo" class="title mb-0">Monto</label>
                                        <input value="" type="text" id="montoEfectivo" class="form-control"
                                            placeholder="Monto" required #montoEfectivo formControlName="monto"
                                            [(ngModel)]="montoPago" monto />
                                        <div *ngIf="
                                                formDeposito.get('monto').invalid &&
                                                (formDeposito.get('monto').dirty ||
                                                formDeposito.get('monto').touched) &&
                                                (submittedmedioPago)
                                            ">
                                            <mdb-error
                                                *ngIf="formDeposito.get('monto').hasError('required') || formDeposito.get('monto').hasError('min')">
                                                Ingrese monto
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'"
                                            required formControlName="fecha">
                                        </mdb-date-picker>
                                        <label>Fecha</label>
                                        <div *ngIf="
                                                                                formDeposito.get('fecha').invalid &&
                                                                                (formDeposito.get('fecha').dirty ||
                                                                                formDeposito.get('fecha').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formDeposito.get('fecha').hasError('required')">
                                                Ingrese fecha
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-select label="Banco" placeholder="Banco" [filterEnabled]="true"
                                            formControlName="banco" [options]="optionsBancosEmpresa">
                                        </mdb-select>
                                        <div *ngIf="
                                                                                formDeposito.get('banco').invalid &&
                                                                                (formDeposito.get('banco').dirty ||
                                                                                formDeposito.get('banco').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formDeposito.get('banco').hasError('required')">
                                                Ingrese banco
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                                <div class="col" style="max-width: 200px;">
                                    <div class="md-form">
                                        <mdb-select label="Nro. cuenta" placeholder="Cuenta" [filterEnabled]="true"
                                            formControlName="nroCuenta" [options]="optionsCuentasBancosDeposito">
                                        </mdb-select>
                                        <div *ngIf="
                                                                                formDeposito.get('nroCuenta').invalid &&
                                                                                (formDeposito.get('nroCuenta').dirty ||
                                                                                formDeposito.get('nroCuenta').touched) &&
                                                                                (submittedmedioPago)
                                                                            ">
                                            <mdb-error *ngIf="formDeposito.get('nroCuenta').hasError('required')">
                                                Ingrese nro. de cuenta
                                            </mdb-error>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <!-- FOOTER -->
                        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
                            <div></div>
                            <button mdbBtn type="submit" size="sm" color="secondary" size="sm" mdbWavesEffect
                                [disabled]="!enabled">
                                Agregar
                            </button>
                        </div>
                    </div>
                </form>
            </mdb-tab>
        </mdb-tabset>
    </div>
</div>
